var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.25 8C13.25 10.3472 11.3472 12.25 9 12.25C7.98718 12.25 7.05892 11.8967 6.32882 11.3059C6.00682 11.0453 5.53457 11.0951 5.27401 11.4171C5.01345 11.7391 5.06326 12.2114 5.38525 12.4719C6.37263 13.2709 7.63138 13.75 9 13.75C12.1756 13.75 14.75 11.1756 14.75 8C14.75 4.82436 12.1756 2.25 9 2.25C6.37548 2.25 4.16165 4.00836 3.47229 6.41129L3.19636 5.72145C3.04252 5.33687 2.60605 5.1498 2.22146 5.30364C1.83687 5.45747 1.64981 5.89395 1.80364 6.27854L2.80364 8.77854C2.95748 9.16313 3.39396 9.35019 3.77854 9.19635L6.27854 8.19636C6.66313 8.04252 6.85019 7.60604 6.69636 7.22146C6.54252 6.83687 6.10605 6.64981 5.72146 6.80364L4.83321 7.15894C5.22353 5.21458 6.94073 3.75 9 3.75C11.3472 3.75 13.25 5.65279 13.25 8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.8a5f6d1436a29f273f5e351e2e34f4e6.svg";
export { ForwardRef as ReactComponent };